import { reasoningEffortForThinking } from "@perceptron/api/apiContracts/chatCompletions";
import type { DetectExportConfig } from "@perceptron/api/codeGenerators";

import { env } from "@demo/env";
import type { DetectImage, DetectOutput } from "@demo/store/detect";

/** Placeholder emitted when there's no usable image URL (no image, or a base64 `data:` URL). */
const IMAGE_URL_PLACEHOLDER = "<IMAGE_URL>";

export interface BuildDetectConfigParams {
  image?: DetectImage;
  categories: string[];
  outputType: DetectOutput;
  enableThinking: boolean;
  apiKey: string;
}

/**
 * Build a {@link DetectExportConfig} from the detect store. Uses an uploaded
 * `https` image URL when one exists, but never inlines a multi-MB base64 `data:`
 * URL — it emits an `<IMAGE_URL>` placeholder instead. `categories` is omitted
 * when empty so the snippet matches the gateway's "absent ≠ []" handling.
 */
export function buildDetectConfig(params: BuildDetectConfigParams): DetectExportConfig {
  const { image, categories, outputType, enableThinking, apiKey } = params;

  const imageUrl = image?.url && !image.url.startsWith("data:") ? image.url : IMAGE_URL_PLACEHOLDER;

  return {
    apiUrl: `${env.NEXT_PUBLIC_API_BASE_URL}/v1/detect`,
    apiKey,
    imageUrl,
    categories: categories.length > 0 ? categories : undefined,
    output: outputType,
    reasoningEffort: reasoningEffortForThinking(enableThinking),
  };
}
